import React from "react";

/**
 * On/off switch for "Visible on the site", with the state in words beside
 * it (not colour alone). Its accessible name is the item name (via
 * `labelledBy`) plus "Visible on the site"; aria-checked carries the state.
 *
 * @param {object} props
 * @param {boolean} props.checked
 * @param {boolean} [props.busy]
 * @param {() => void} props.onToggle
 * @param {string} props.id - Unique id; the label text gets `${id}-label`
 * @param {string} [props.labelledBy] - Id of the item's name, for lists
 */
export default function VisibleSwitch({ checked, busy, onToggle, id, labelledBy }) {
  const labelId = `${id}-label`;
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-labelledby={[labelledBy, labelId].filter(Boolean).join(" ")}
      className={`cms-switch${checked ? " is-on" : ""}`}
      onClick={onToggle}
      disabled={busy}
      data-testid="visible-switch"
    >
      <span className="cms-switch__track" aria-hidden="true">
        <span className="cms-switch__thumb" />
      </span>
      <span className="cms-switch__text">
        <span id={labelId}>Visible on the site</span>
        <span className="cms-switch__state" aria-hidden="true">{checked ? "On" : "Off"}</span>
      </span>
    </button>
  );
}
